module.exports = __webpack_public_path__ + "img/chevronDown.680ec697.svg";